// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartFulfillmentMethodStyles } from "@pace/Overrides/Widgets/Cart/CartFulfillmentMethodSelector";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { mergeWithCss } from "@pace/XDL/Utilities";
import { css } from "styled-components";

cartFulfillmentMethodStyles.container = {
    css: css`
        flex-direction: column;
        margin: 0 0 32px;
    `,
};
cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = {
    labelProps: {
        size: 16,
        weight: fontConfig.weight.bold,
    },
};
// XNG-Changes: PAC-957

cartFulfillmentMethodStyles.pickUpLocation = {
    ...mergeWithCss(cartFulfillmentMethodStyles.pickUpLocation, {
        changeLink: {
            typographyProps: {
                size: 12,
            },
        },
    }),
};
